export default __webpack_public_path__ + "static/howWeWork1-14b2abf0bd6f5a12c61e6518e7c0aa87.png";